import * as React from 'react';
const SvgDownload = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M4.757 16.583q-.555 0-.948-.392a1.3 1.3 0 0 1-.392-.947V7.755q0-.554.392-.947.393-.392.948-.392h2.34a.526.526 0 0 1 .54.537.53.53 0 0 1-.155.387.52.52 0 0 1-.386.159h-2.34a.25.25 0 0 0-.184.072.25.25 0 0 0-.072.184v7.487a.25.25 0 0 0 .072.185.25.25 0 0 0 .185.072h10.487a.25.25 0 0 0 .184-.072.25.25 0 0 0 .072-.185V7.756a.25.25 0 0 0-.072-.184.25.25 0 0 0-.184-.072h-2.34a.527.527 0 0 1-.542-.537q0-.23.156-.388a.52.52 0 0 1 .386-.158h2.34q.555 0 .947.392.393.393.392.947v7.487q0 .555-.392.948a1.3 1.3 0 0 1-.947.392zm5.785-5.953 1.019-1.02a.55.55 0 0 1 .39-.176.5.5 0 0 1 .384.168q.18.181.181.388 0 .206-.18.387l-1.874 1.873a.64.64 0 0 1-.466.202.62.62 0 0 1-.46-.205l-1.87-1.87a.5.5 0 0 1-.163-.387.58.58 0 0 1 .183-.388q.18-.18.387-.18.206 0 .387.18l.998 1.028V2.166a.526.526 0 0 1 .538-.541q.228 0 .387.155a.52.52 0 0 1 .159.386z'
            />
        </g>
    </svg>
);
export default SvgDownload;
